/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvironmentCode } from './environments/environment.model';

if (environment.env === EnvironmentCode.prod) {
  enableProdMode();
}

if (environment.sentryConfiguration) {
  Sentry.init({
    dsn: environment.sentryConfiguration.dsn,
    environment: environment.env,
    release: environment.sentryConfiguration.releaseVersion,
    sendDefaultPii: environment.sentryConfiguration.sendDefaultPii,
    tracesSampleRate: environment.sentryConfiguration.tracesSampleRate,
    tracePropagationTargets: [environment.apiRootUrl],
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event, hint) {
      if (
        event.exception?.values?.[0]?.stacktrace?.frames?.some(
          (f) => f.filename?.startsWith('chrome-extension://') || f.filename?.startsWith('moz-extension://'),
        )
      ) {
        return null;
      }

      if (event.message === 'Script error.') {
        return null;
      }

      const orig = hint.originalException;
      const msg = (orig as Error)?.message || '';
      const ignoredErrors = [
        'ResizeObserver loop limit exceeded',
        'ExpressionChangedAfterItHasBeenCheckedError',
        'Non-Error promise rejection captured',
        'Script error',
        'Network request failed',
      ];

      if (ignoredErrors.some((error) => msg.includes(error))) {
        return null;
      }

      if (event.request?.url) {
        event.request.url = event.request.url.replace(/([?&]token=)[^&]+/gi, '$1***');
      }

      return event;
    },
  });
}

platformBrowserDynamic().bootstrapModule(AppModule);
